









































import Vue from "vue";
import { mapState } from "vuex";
import AssignmentList from "../components/assignments/assignment-list.vue";
import GoalFilter from "../components/assignments/goal-filter.vue";
import AssignmentTrackerFilter from "../components/assignments/assignment-tracker-filter.vue";
import VideoPlayer from "../components/video-player/video-player.vue";

export default Vue.extend({
  components: {
    GoalFilter,
    "assignment-tracking-filter": AssignmentTrackerFilter,
    AssignmentList,
    VideoPlayer
  },
  data() {
    return {
      isCollapsed: false,
      viewType: null,
      currentGoal: null,
      currentGoalId: null,
      currentTrackerId: null,
      showVideoPlayer: false,
      videoId: "353716477"
    };
  },
  computed: {
    ...mapState("goal", ["loading"])
  },
  methods: {
    handleGoalFilter(filter) {
      this.currentGoalId = filter.goalId;
      this.currentGoal = filter.goal;
    },
    handleFilter(filter) {
      this.viewType = filter.viewType;
      this.currentTrackerId = filter.trackerId;
    },
    handleRefreshClick() {
      if (this.currentGoalId) {
        this.$store.dispatch("goal/get", { id: this.currentGoalId });
      }
    },
    handleVideoClick(type, url) {
      this.videoId = "";
      let match = url.match(/(?<=player\.vimeo\.com\/video\/)[0-9]*/g);
      if (match != null && match.length == 1) {
        this.videoId = match[0];
      }

      this.showVideoPlayer = true;
    },
    memberRoleNameResolver(memberId) {
      let members = (this as any).currentGoal && (this as any).currentGoal.members ? (this as any).currentGoal.members.filter(m => m.memberId == memberId) : [];
      if (members.length === 1) {
        let member = members[0];
        return member.role == 5 ? "Member" : member.role == 2 ? this.currentGoal.parentRoleName : member.role == 3 ? this.currentGoal.childRoleName : "";
      } else {
        return "";
      }
    }
  }
});
